import React from 'react';
import ReactDOM from 'react-dom';
import './core/i18n/i18n'

import './index.css';
import PatientApp from "./PatientApp";
import HisApp from "./HisApp";
import { LocalStorageService } from "./core/service/LocalStorageService";
import PatientLocalStorage from "./patient-app/PatientLocalStorage";
import ApiService from "./core/service/ApiService";
import {startVersionWatch} from "./core/service/VersionWatcher";

const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';

window.addEventListener('error', (e) => {
    if (e.message && e.message.includes(resizeObserverLoopErr)) {
        e.stopImmediatePropagation();
    }
});

const init = async (module) => {
    const res = await fetch('/configuration.json')
    const config = window.AppSettings
    document.querySelector('meta[name="description"]').setAttribute('content', config[module].description[LocalStorageService.getLanguage('tr')]);
    document.title = config[module].title[LocalStorageService.getLanguage('tr')];

    document.querySelector('link[rel="icon"]').setAttribute('href', config.theme.favicon);
    document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', config.theme.favicon);
}

const loadPatient = async () => {
    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await init('online')

    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');
    if (accessToken) {
        PatientLocalStorage.saveToken(accessToken)
        const res = await ApiService.PatientApp.GetPatient()
        if (res.success) {
            PatientLocalStorage.saveInformation(res.data)
        }
    }

    ReactDOM.render(
        <PatientApp />,
        document.getElementById('root')
    );

    startVersionWatch();
}

const loadHIS = async () => {
    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await init('his')

    ReactDOM.render(
        <HisApp />,
        document.getElementById('root')
    );

    startVersionWatch();
}

//loadPatient()
loadHIS()
